import { QueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

export const no4xxRetry = (failureCount: number, error: unknown) => {
  if (
    error instanceof AxiosError &&
    error.response?.status !== undefined &&
    error.response.status >= 400 &&
    error.response.status < 500
  )
    return false;
  return failureCount < 3;
};

export const apiv2QueryClient = new QueryClient({
  defaultOptions: { queries: { retry: no4xxRetry } },
});
